export const defaultInProgressRequestBody = {
  PageNum: 1,
  pageSize: 30,
  SortColumn: "",
  IsAsc: false,
  TenantId: 0,
  TranscriptionTypeId: 0,
  PackPriorityId: 0,
  Keyword: "",
  StatusId: 0,
};

export const defaultCompletedRequestBody = {
  PageNum: 1,
  pageSize: 30,
  SortColumn: "",
  IsAsc: false,
  TenantId: 0,
  TranscriptionTypeId: 0,
  PackPriorityId: 0,
  Keyword: "",
  StatusId: 3,
};

export const defaultArchivedRequestBody = {
  PageNum: 1,
  pageSize: 30,
  SortColumn: "",
  IsAsc: false,
  TenantId: 0,
  TranscriptionTypeId: 0,
  PackPriorityId: 0,
  Keyword: "",
  StatusId: 5,
};
export const defaultNewCompletedRequestBody = {
  PageNum: 1,
  pageSize: 30,
  SortColumn: "",
  IsAsc: false,
  TenantId: 0,
  TranscriptionTypeId: 0,
  PackPriorityId: 0,
  Keyword: "",
  StatusId: 0,
};

export const defaultRequestBody = {
  PageNum: 1,
  pageSize: 30,
  SortColumn: "",
  IsAsc: false,
  Keyword: "",
};

export type DefaultInProgressRequestBodyType = typeof defaultInProgressRequestBody;
export type DefaultCompletedRequestBodyType = typeof defaultCompletedRequestBody;
export type DefaultArchivedRequestBodyType = typeof defaultArchivedRequestBody;
export type DefaultNewCompletedRequestBodyType = typeof defaultNewCompletedRequestBody;
export type DefaultRequestBodyType = typeof defaultRequestBody;
